import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {DELETE_PROFILE} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getAllProfiles from "./getAllProfiles";
import loadingCall from "../helpers/loadingCall";

const deleteProfile= (id) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/deleteProfile', {id: id}));
  handleResponse(dispatch, response, DELETE_PROFILE, data => onSuccessPayload(data, getState), null, [getAllProfiles]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].profileDeleted);
};
export default deleteProfile;